export const ErrorFallback = () => {
  return (
    <div className="mx-16 flex flex-col items-center justify-center rounded-medium bg-Gray-white p-20">
      <p className="text-Gray-600 typo-body3">
        데이터를 불러오는데 실패했습니다.
      </p>
    </div>
  );
};
